export function Page404() {
  return (
    <div>
      <h1>The requested page has not been found. </h1>
    </div>
  );
}
